export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      /**
       * Add highlighted text when the text contains '|' character for example "Hello |world|"
       * @returns {string} with proper html tags for example "Hello <span class="highlighted">world</span>"
       */
      function addHighlightedText(text) {
        return text
          .split('|')
          .map((part, index) => {
            if (index > 0 && index % 2 !== 0) {
              const [innerText, rest] = part.split('|');
              return `<span class="bg-primary-600 px-3 py-0 rounded-lg text-white">${innerText}</span>${rest ?? ''}`;
            }
            return part;
          })
          .join('');
      }

      /**
       * Add color text when the text contains '--' character for example "Hello --world--"
       * @returns {string} with proper html tags for example "Hello <span class="coloredText">world</span>"
       */
      function addColorText(text) {
        return text
          .split('--')
          .map((part, index) => {
            if (index > 0 && index % 2 !== 0) {
              const [innerText, rest] = part.split('--');
              return `<span class="text-primary-600">${innerText}</span>${rest ?? ''}`;
            }
            return part;
          })
          .join('');
      }

      instance.data('TextStyling', (text) => {
        let outputText = text;

        if (text.includes('|')) {
          outputText = addHighlightedText(outputText);
        }

        if (text.includes('--')) {
          outputText = addColorText(outputText);
        }

        return { outputText };
      });
    });
  },
};
